import { useState } from "react";
import { Popconfirm } from "antd";
import images from "../../assets";
import { PrimaryButton, PendingButton } from "../button";

export default function UserDescriptionBox({
  title,
  desc,
  editicon,
  editbtntext,
  editDesc,
  approvetext,
  approvedesc,
  rejecttext,
  rejectdesc,
  ...props
}) {
  const [updatedDesc, setUpdatedDesc] = useState(desc);

  return (
    <div className="w-full rounded-2xl border border-primary5" {...props}>
      <div className="p-4 w-full flex-col gap-4 inline-flex">
        <div className="text-[#222222] text-sm font-semibold">{title}</div>
        <div className="border border-primary50 p-3 rounded-2xl">
          <textarea
            value={updatedDesc}
            className="w-full outline-none p-2"
            onChange={(e) => setUpdatedDesc(e.target.value)}
          />
        </div>
        <div className="items-center gap-2 flex">
          Status:
          <PendingButton />
        </div>
      </div>
      <div className="w-full p-4 bg-[#f5f6f7] rounded-b-2xl justify-center items-center gap-5 flex">
        <Popconfirm
          title={approvetext}
          description={approvedesc}
          onConfirm={() => editDesc(updatedDesc, "approved")}
          okText="Yes"
          cancelText="No"
        >
          <PrimaryButton
            style={{
              width: "50%",
              height: "48px",
              fontSize: "14px",
              background: "#17c964",
            }}
            text={"Approve"}
            iconalign="left"
            icon={images.checkWhiteIcon}
          />
        </Popconfirm>

        <Popconfirm
          title={rejecttext}
          description={rejectdesc}
          onConfirm={() => editDesc(updatedDesc, "rejected")}
          okText="Yes"
          cancelText="No"
        >
          <PrimaryButton
            style={{
              width: "50%",
              height: "48px",
              fontSize: "14px",
              background: "#f31260",
            }}
            text={"Reject"}
            iconalign="left"
            icon={images.rejectWhiteIcon}
          />
        </Popconfirm>
      </div>
    </div>
  );
}
